"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const useKey_1 = tslib_1.__importDefault(require("./useKey"));
const useEsc = (callback) => {
    (0, useKey_1.default)(event => event.key === 'Escape' && callback(event));
};
exports.default = useEsc;
